import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const AddAndSearchItemContainer = styled.div`
    display: flex;
    ${media.mobileDevice`
        display:block;
        margin-top:${(props) => props.isFromReportScreen && '15px'}
    `}
    ${media.mediumDevice`
        width:100%;
        flex-direction:column;
        margin-left:1px;
        margin-right:2px;
   `}
    .buttonStyle {
        background: none;
        color: #202124;
        border-radius: 0px;
        font-size: 13px;
        font-family: 'AvenirNextWorld Regular';
        padding: 2px 1px 1px 0px !important;
        text-transform: none !important;
        border-bottom: 2px solid #fff !important;
        margin-right: 15px;
        letter-spacing: 0px;
    }

    .buttonStyleWithBorder {
        color: #202124;
        border-radius: 0px;
        font-size: 13px;
        border-bottom: 2px solid #1010eb !important;
        box-shadow: 0 0 0 0 rgb(211 212 213 / 0%) !important;
        font-weight: bold;
        font-family: 'AvenirNextWorld Demi';
        padding: 2px 1px 1px 0px !important;
        text-transform: none !important;
        margin-right: 15px;
        letter-spacing: 0px;
    }

    .inputSearch {
        height: 40px;
        padding-left: 16px;
        background: #ffffff 0% 0% no-repeat padding-box;
        border: 2px solid #ebeded;
        border-radius: 4px;
        padding-right: 16px;
        font-size: 14px;
        margin-left: ${({ marginLeftInput }) =>
            marginLeftInput ? marginLeftInput : '10px'};
    }
    .searchtStyle {
        border-width: 0 !important;
        width: 100% !important;
        outline: 0 !important;
        padding: 6px !important;
    }
    .cardContainer {
        box-shadow: ${({ boxShadow }) =>
            boxShadow ? boxShadow : '0px 0px 6px #00000029'};

        width: ${({ width }) => (width ? width : '50%')};
        ${media.mediumDevice`
            width:100%;
            display:flex;
            flex-direction:column;
       `}
        ${media.mobileDevice`
    width:100%;
   `}
        background: #FFFFFF 0% 0% no-repeat padding-box;
        border-radius: 6px;
    }
    .inputStyle,
    .inputStyle:focus,
    .inputStyle:active,
    .inputStyle:focus-visible {
        border-width: 0 !important;
        width: 100% !important;
        outline: 0 !important;
        padding: ${({ padding }) => (padding ? padding : '10px !important')};
        margin: auto;
    }
    .cardHeader {
        background: #fff;
        border-width: 0;
        margin-left: ${({ marginLeft }) =>
            marginLeft ? marginLeft : '1rem!important'};
        width: max-content;
        ${media.mobileDevice`
        width: auto;
        `}
    }
    .MuiAutocomplete-inputFocused {
        opacity: 1;
        border: 0 !important;
        outline: 0;
        border-width: 0 !important; 
        outline: 0 !important;
        padding: 10px !important;

        @media (min-width: 768px) {
        width: 87% !important;
        }
    }
    .textMuted {
        font-size: 6px !important;
        color: red !important;
    }
    .notificationBox {
        display: flex;
        border: none;
        padding: 8px 0 0 10px;
    }
    .notificationText {
        color: #14853d;
        font-size: 14px;
        padding-left: 7px;
    }
`;
export const AddInputStyle = styled.input.attrs(() => ({
    enterKeyHint: 'go',
}))`
    border-width: 0 !important;
    width: 100% !important;
    outline: 0 !important;
    padding: ${({ padding }) => (padding ? padding : '10px !important')};
    font-size: ${({ fontSize }) => fontSize};
    font-family: ${({ fontFamily }) => fontFamily};
    color: ${({ color }) => color};
    // opacity: ${({ opacity }) => opacity};
    margin-left: ${({ placeholderMarginLeft }) => placeholderMarginLeft};
    line-height: ${({ lineHeightInputStyle }) => lineHeightInputStyle};
`;

export const ButtonDiv = styled.div`
    display: flex;
    justify-content: flex-end;
    width: ${({ width }) => (width ? width : null)};
    @media screen and (min-width: 768px) and (max-width: 768px) and (orientation: portrait) {
        width: 73%;
    }
    ${media.mobileDevice`
     width: 73%;

    `}
`;
